import {
  Button,
  Modal,
  notification,
  Popconfirm,
  Table,
  Tooltip,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { alertError } from "../../../utils/alert";
import { getList } from "../../../Graphs/Master/IP/getList";
import { deleteIP } from "../../../Graphs/Master/IP/deleteIP";
import { AddIPModal } from "./AddIPModal";
import { addIP } from "../../../Graphs/Master/IP/addIP";

const AddIPModel = ({ onClose = () => {}, id, myProps }) => {
  const [ipList, setIpList] = useState([]);
  const [isAddIP, setAddIP] = useState(false);
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    fetchIPList(pagination.current, pagination.pageSize);
  }, []);

  const fetchIPList = async (page, pageSize) => {
    setLoading(true);
    try {
      const startIndex = (page - 1) * pageSize;
      const response = await getList(
        id,
        myProps.authToken,
        startIndex,
        pageSize
      );
      if (response.status === 200 && response.data) {
        setIpList(response.data);
        setPagination((prev) => ({
          ...prev,
          total: response.total || response.data.length, // use proper total if available
        }));
      } else {
        throw response.message || "Failed to fetch IPs";
      }
    } catch (error) {
      alertError("FETCH_IPS", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchIPList(pagination.current, pagination.pageSize);
  };

  const handleDeleteIP = async (item) => {
    setLoading(true);
    try {
      const deleteData = await deleteIP(
        myProps.authToken,
        item.id,
        0,
        pagination.pageSize
      );
      if (deleteData.status === 200) {
        notification.success({
          message: "Delete IP",
          description: "Successfully deleted",
        });
        fetchIPList(pagination.current, pagination.pageSize); // Refresh the list
      } else {
        throw deleteData?.message || "Error";
      }
    } catch (err) {
      alertError("DELETE_IP", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddIP = async (ipData) => {
    setLoading(true);
    try {
      const response = await addIP(myProps.authToken, ipData, id);
      if (response.status === 200) {
        notification.success({
          message: "Add IP",
          description: "IP added successfully",
        });
        setAddIP(false);
        fetchIPList(pagination.current, pagination.pageSize);
      } else {
        throw response.message || "Failed to add IP";
      }
    } catch (error) {
      notification.error({
        message: "Add IP",
        description: error.message || "Failed to add IP",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      render: (text, item, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "IP Address",
      key: "ip_address",
      render: (text, item) => <strong>{item.ip_address}</strong>,
    },
    {
      title: "Actions",
      key: "action",
      width: 135,
      render: (text, item) => (
        <Tooltip placement="bottom" title="Delete">
          <Popconfirm
            onConfirm={() => handleDeleteIP(item)}
            title="Are you sure you want to delete this IP?"
            okButtonProps={{ loading }}
          >
            <Button
              shape="circle"
              icon={<DeleteOutlined />}
              disabled={loading}
            />
          </Popconfirm>
        </Tooltip>
      ),
    },
  ];

  return (
    <Modal
      width="800px"
      title="Manage IPs"
      open={true}
      onCancel={onClose}
      footer={[
        <Button key="add" onClick={() => setAddIP(true)} disabled={loading}>
          Add IP
        </Button>,
        <Button key="close" onClick={onClose} disabled={loading}>
          Close
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Table
          rowKey={(record) => record._id}
          columns={columns}
          size="small"
          dataSource={ipList}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </Spin>

      {isAddIP && (
        <AddIPModal
          userId={id}
          onSubmit={handleAddIP}
          onCancel={() => setAddIP(false)}
          type="ip"
          primaryColor="#4466f2"
        />
      )}
    </Modal>
  );
};

export default AddIPModel;
